import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import UserMenu from "@/components/UserMenu";

const nav = [
  { to: "/", label: "Home", end: true },
  { to: "/projects", label: "Projects" },
  { to: "/emi", label: "EMI Calculator" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-border" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-home-logo">
          <img src="/brand/ofr-mark.png" alt="Our First Realty" className="w-10 h-10 rounded-md object-cover" />
          <div className="leading-tight">
            <div className="font-heading font-bold text-forest text-lg tracking-tight">Our First Realty</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Your first step to the right property</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}-link`}
              className={({ isActive }) =>
                `text-sm transition-colors ${isActive ? "text-forest font-semibold" : "text-muted-foreground hover:text-forest"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <UserMenu />
        </nav>

        <button
          className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-md border border-border"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-white" data-testid="mobile-nav-panel">
          <div className="px-6 py-4 flex flex-col gap-3">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) => `py-2 text-sm ${isActive ? "text-forest font-semibold" : "text-muted-foreground"}`}
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
